import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withApollo } from '@apollo/client/react/hoc';
import { ISSUES_GROUP, VCS_FROM_SLUG } from '../constants/api';
import { HANDLED_ERRORS } from '../constants/types';
import { replaceAsciiCharWithSlash, replaceSlashWithAsciiChar, resolveBranchName } from '../utils/resolveBranch';
import ApiV2ModelContext from '../contexts/ApiV2ModelContext';
import { getActiveBranch } from '../pages/RepositoryPage';
import { urlContainsGroup } from '../pages/CommitPage';
import { LoadingDefects } from './Defects/LoadingDefects';
import { Defects } from './Defects/Defects';
import { resolveFilterGroupType } from './Defects/Tabs';
import * as types from '../constants/ActionTypes';
import DefectList from '../model/entities/DefectList';
export function resolveStoredDefectsForCommit(commitHash, repositoryId, activeBranchId, storedDefects) {
    if (repositoryId in storedDefects) {
        if (activeBranchId in storedDefects[repositoryId]) {
            if (commitHash in storedDefects[repositoryId][activeBranchId]) {
                return storedDefects[repositoryId][activeBranchId][commitHash];
            }
        }
    }
    return {};
}
export class MostCommonIssues extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false,
            commitIssuesData: [],
            loadingMore: false,
            issuesLimit: 10,
            moreIssuesCount: 0,
        };
        this.loadCommonIssuesData = async (newLimit) => {
            const { limit, commitHash, fetchCommonIssues, hiddenType, location, onlyNew, storedDefects, repository, activeBranches } = this.props;
            const limitForIssues = newLimit ? newLimit : limit;
            const resolvedType = resolveFilterGroupType(hiddenType);
            const activeBranch = getActiveBranch(repository, activeBranches);
            const storedDefectsForCommit = resolveStoredDefectsForCommit(commitHash, repository.id, activeBranch.id, storedDefects);
            const storedDefectsByType = Object.keys(storedDefectsForCommit).includes(resolvedType) ? storedDefectsForCommit[resolvedType] : new DefectList([], 0);
            if (!fetchCommonIssues) {
                this.setState({
                    loading: false,
                    commitIssuesData: storedDefectsByType.defects,
                    moreIssuesCount: storedDefectsByType.totalNodes - limitForIssues,
                    issuesLimit: limitForIssues,
                    loadingMore: false,
                });
            }
            if (fetchCommonIssues && commitHash) {
                if (limitForIssues) {
                    this.setState((prevState) => ({
                        loadingMore: true,
                        issuesLimit: prevState.issuesLimit > limitForIssues ? prevState.issuesLimit : limitForIssues,
                    }));
                }
                const group = resolveFilterGroupType(hiddenType);
                const isTypeFilterActive = !!(hiddenType && group !== ISSUES_GROUP.ALL && urlContainsGroup(location.pathname));
                const loadQuery = !!newLimit || isTypeFilterActive;
                await this.loadMostCommonIssues(limitForIssues, !onlyNew, loadQuery, isTypeFilterActive ? group : '');
            }
        };
        this.loadMostCommonIssues = async (limitForIssues, showAll, loadQuery, issueType) => {
            const { dispatch, match, onlyNew, commitHash, hiddenType, repository, activeBranches, storedDefects } = this.props;
            const resolvedType = resolveFilterGroupType(hiddenType);
            const activeBranch = getActiveBranch(repository, activeBranches);
            const storedDefectsForCommit = resolveStoredDefectsForCommit(commitHash, repository.id, activeBranch.id, storedDefects) ?? [];
            const storedDefectsByType = resolvedType in Object.keys(storedDefectsForCommit) ? storedDefectsForCommit[resolvedType] : new DefectList([], 0);
            if (!showAll && onlyNew && !storedDefectsByType?.defects.length) {
                await this.loadMostCommonIssues(limitForIssues, true, true);
            }
            if (loadQuery) {
                try {
                    const vcs = VCS_FROM_SLUG[match.params.vcs];
                    const defectListResponse = await this.context.getDefectList(commitHash, vcs, limitForIssues, !showAll && onlyNew, issueType !== ISSUES_GROUP.ALL ? issueType : '');
                    const { defects, totalNodes: defectsTotalNodes } = defectListResponse;
                    const defectType = onlyNew ? 'new' : issueType === '' ? ISSUES_GROUP.ALL : issueType;
                    await dispatch({
                        type: types.UPDATE_DEFECTS,
                        payload: {
                            type: defectType,
                            defectList: defectListResponse,
                            repositoryId: repository.id,
                            branchId: activeBranch?.id,
                            commitHash,
                            limit: limitForIssues,
                        },
                    });
                    this.setState({
                        loading: false,
                        loadingMore: false,
                        commitIssuesData: defects,
                        moreIssuesCount: defectsTotalNodes - limitForIssues,
                    });
                }
                catch (error) {
                    const statusCode = error.networkError?.statusCode;
                    if (HANDLED_ERRORS.includes(statusCode)) {
                        this.setState({
                            loading: false,
                            loadingMore: false,
                        });
                    }
                    else {
                        throw error;
                    }
                }
            }
            else if (storedDefectsByType.totalNodes) {
                this.setState({
                    loading: false,
                    loadingMore: false,
                    commitIssuesData: storedDefectsByType.defects,
                    moreIssuesCount: storedDefectsByType.totalNodes - limitForIssues,
                });
            }
        };
        this.handleRuleClick = (tool, ruleId) => {
            const { commitHash, history, match, repository, activeBranches } = this.props;
            const identifier = ruleId ? replaceSlashWithAsciiChar(ruleId) : '';
            const mainBranch = repository.getMainBranch();
            let activeBranch = null;
            try {
                activeBranch = getActiveBranch(repository, activeBranches);
                const branchName = `${activeBranch && activeBranch.name !== mainBranch.name ? '/b-' + replaceSlashWithAsciiChar(activeBranch.name) : ''}`;
                history.push(`/${match.params.vcs}/${match.params.owner}/${match.params.repository}${branchName}/commits/${commitHash}/${identifier}`);
            }
            catch (error) {
                console.warn(error);
            }
        };
        this.handleTypeClick = async (type, deselect = false) => {
            const { commitHash, history, match, repository, activeBranches, onlyNew } = this.props;
            const { issuesLimit } = this.state;
            const mainBranch = repository.getMainBranch();
            let activeBranch = null;
            let branchName = '';
            try {
                activeBranch = getActiveBranch(repository, activeBranches);
                branchName = resolveBranchName(activeBranch?.name ?? '', mainBranch.name, activeBranch?.main ?? false);
                await this.loadMostCommonIssues(issuesLimit, !onlyNew, true, type);
            }
            catch (error) {
                console.warn(error);
            }
            const baseUrl = this.resolveCommitDetailBaseUrl(match, branchName, commitHash);
            if (deselect) {
                history.push(baseUrl);
                return;
            }
            history.push(`${baseUrl}/${type ? replaceSlashWithAsciiChar(type) : ''}`);
        };
        this.handleLoadMore = async () => {
            const { limit } = this.props;
            const { issuesLimit } = this.state;
            const newIssuesLimit = issuesLimit + limit;
            await this.loadCommonIssuesData(newIssuesLimit);
        };
    }
    decideWhetherToLoadCommonIssues(props) {
        const { activeBranches, hiddenType, limit, onDashboard, storedDefects, onlyNew, repository, commitHash } = props;
        const { issuesLimit } = this.state;
        const resolvedType = resolveFilterGroupType(hiddenType);
        const activeBranch = getActiveBranch(repository, activeBranches);
        const storedDefectsForCommit = resolveStoredDefectsForCommit(commitHash, repository.id, activeBranch.id, storedDefects);
        const storedDefectsByType = onlyNew && 'new' in storedDefectsForCommit ? storedDefectsForCommit.new : Object.keys(storedDefectsForCommit).includes(resolvedType) ? storedDefectsForCommit[resolvedType] : new DefectList([], 0);
        const isEnoughDefectsByType = storedDefectsByType.defects.length >= issuesLimit || (storedDefectsByType.defects.length > 0 && storedDefectsByType.defects.length === storedDefectsByType.totalNodes);
        if (!isEnoughDefectsByType) {
            this.setState({
                loading: true,
            }, this.loadCommonIssuesData);
        }
        else {
            const newLimit = issuesLimit && !onDashboard ? issuesLimit : limit;
            this.setState(() => ({
                commitIssuesData: storedDefectsByType.defects,
                issuesLimit: newLimit,
                moreIssuesCount: storedDefectsByType.totalNodes - newLimit,
                loading: false,
                loadingMore: false,
            }));
        }
    }
    UNSAFE_componentWillReceiveProps(props) {
        this.decideWhetherToLoadCommonIssues(props);
    }
    componentDidMount() {
        this.decideWhetherToLoadCommonIssues(this.props);
    }
    resolveCommitDetailBaseUrl(match, branchName, commitHash) {
        let url = '';
        const { vcs, owner, repository, subrepository } = match.params;
        if (vcs && owner && repository) {
            url = `/${vcs}/${owner}/${repository}`;
        }
        if (subrepository) {
            url = `${url}/${subrepository}`;
        }
        if (branchName) {
            url = `${url}/${branchName}`;
        }
        if (commitHash) {
            url = `${url}/commits/${commitHash}`;
        }
        return replaceAsciiCharWithSlash(url);
    }
    render() {
        const { showMoreBtn, className, onRuleClick, onTypeClick, hiddenType, twoColumns, isCommitProcessing, isCommitTimedOut, icons, highlightedRules, errorCount, warningCount, commitHash, filterByNewIssues, location, showEmpty, children, filteredFiles, onDashboard, showLoading, } = this.props;
        const { loading, loadingMore, issuesLimit, commitIssuesData, moreIssuesCount } = this.state;
        const handleTypeClick = async (type) => {
            return onTypeClick ? onTypeClick(type) : this.handleTypeClick(type);
        };
        if (!isCommitProcessing && ((loading && commitIssuesData.length) || showLoading)) {
            return _jsx(LoadingDefects, { showTabs: !onDashboard, children: children });
        }
        if (!commitIssuesData.length && showEmpty) {
            return null;
        }
        return _jsx(Defects, { issuesLimit: issuesLimit, showMoreBtn: showMoreBtn, showIcon: icons, twoColumns: twoColumns, defects: commitIssuesData, moreIssuesCount: moreIssuesCount, highlightedRules: highlightedRules, loadingMore: loadingMore, className: className, hiddenType: hiddenType, loading: loading, isCommitProcessing: isCommitProcessing, isCommitTimedOut: isCommitTimedOut, locationPathname: location.pathname, filterByNewIssues: filterByNewIssues, errorCount: errorCount, warningCount: warningCount, commitHash: commitHash, showTabs: !!filteredFiles, onRuleClick: onRuleClick || this.handleRuleClick, onTypeClick: onTypeClick || this.handleTypeClick, onLoadMoreClick: this.handleLoadMore, onTabClick: handleTypeClick, children: children });
    }
}
MostCommonIssues.contextType = ApiV2ModelContext;
MostCommonIssues.defaultProps = {
    twoColumns: false,
    showEmpty: false,
    showMoreBtn: false,
    onlyNew: false,
    limit: 10,
    highlightedRules: [],
    onRuleClick: void 0,
    className: '',
    hiddenType: '',
    icons: false,
    errorCount: 0,
    warningCount: 0,
    filterByNewIssues: false,
    onDashboard: false,
    fetchCommonIssues: false,
    showLoading: false,
};
const mapStateToProps = (state) => ({
    repository: state.repository.repository,
    activeBranches: state.activeBranches,
    storedDefects: state.defects,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch,
});
export default withRouter(
// @ts-expect-error TS2345: Argument of type is not assignable to parameter of type
connect(mapStateToProps, mapDispatchToProps)(withApollo(MostCommonIssues)));
